import { clsx } from 'clsx'
import type { LucideIcon } from 'lucide-react'
import { Construction } from 'lucide-react'

interface PagePlaceholderProps {
  title: string
  description: string
  icon?: LucideIcon
  className?: string
}

export function PagePlaceholder({
  title,
  description,
  icon: Icon = Construction,
  className,
}: PagePlaceholderProps) {
  return (
    <div className={clsx('flex flex-col items-center justify-center min-h-[400px] text-center', className)}>
      <div className="h-14 w-14 rounded-2xl bg-[--km-surface-2] border border-[--km-border] flex items-center justify-center mb-4">
        <Icon size={24} className="text-[--km-text-muted]" />
      </div>
      <h2 className="text-lg font-semibold text-[--km-text-primary] mb-2">{title}</h2>
      <p className="text-sm text-[--km-text-secondary] max-w-xs leading-relaxed">{description}</p>
      <div className="mt-6 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20">
        <span className="text-xs font-medium text-[--km-primary]">Prossimamente</span>
      </div>
    </div>
  )
}
